import {Hydra} from '../generic/hydra';

import {DossierInterface} from './Dossier';
import {UtilisateurInterface} from './Utilisateur';
import {FormulaireSaisieInterface} from './FormulaireSaisie';
import {DossierExpert as DossierExpertBaseInterface} from '../../interface/api/DossierExpert';
import {EvaluationSubresourceItem} from '../../interface/api/Evaluation';

export type DossierExpertInterface = DossierExpertBaseInterface;

export class DossierExpert extends Hydra implements DossierExpertInterface {

    id?: number | null;

    etat?: number | null = 0;

    lienDeclare?: boolean | null = false;

    commentaire?: string | null;

    /* Objet de type Dossier
     */
    dossier?: DossierInterface | string | null;

    evaluation?: EvaluationSubresourceItem | null;

    /* Objet de type Utilisateur
     */
    expert?: UtilisateurInterface | string | null;

    formulaireSaisie?: FormulaireSaisieInterface | string | null;

    dateCreation?: string | Date | null;

    dateValidation?: string | Date | null;

    dateLimiteSaisie?: string | Date | null;

    /* Actions autorisées sur cet objet
     */
    allowedActions?: {view_full: boolean; edit_dossier_expert: boolean; valider_dossier_expert: boolean; reprise_saisie_dossier_expert: boolean; modifier_acceptation: boolean};

    noteGlobale?: { value: string; translations: { locale: string; label: string }[] };

    rapportScientifique?: { id: number; numero: string; } | null;

    constructor(options: DossierExpertInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
